import { createReducer, on } from "@ngrx/store";
import { ApuStandardCategoryTypeActions } from "./apu-standard-category-type.actions";
import { apuStandardCategoryTypeAdapter, initialApuStandardCategoryType } from "./apu-standard-category-type.state";

export const apuStandardCategoryTypeReducer = createReducer(
    initialApuStandardCategoryType,
    on(ApuStandardCategoryTypeActions.loadApuStandardCategoryTypeSuccess, (state, action) => {
        return apuStandardCategoryTypeAdapter.setAll(action.apuStandardCategoryTypes, {
            ...state,
            errorMessage: null
        });
    })
);